import React from 'react'

const SingleEmployesAttendance = ({break_time
  ,
    check_in_type
 ,
    check_out_type
 ,
    company
,
    company_id
,
    date
,
    date_out
,
    early_out_time
,
    employe
,
    employe_id
 ,
    id
,
    in_branch
  ,
    in_branch_id
  ,
    in_time
 ,
    late_time
,
    out_branch
,
    out_branch_id
 ,
    out_time
,
    over_time
,
    work_hour}) => {
  return (
    <tr>
        <td>{id}</td>
        <td>{employe}</td>
        <td>{check_in_type}</td>
        <td>{check_out_type}</td>
        <td>{in_branch}</td>
        <td>{in_time}</td>
        <td>{late_time}</td>
        <td>{date}</td>
        <td>{company}</td>
    </tr>
  )
}

export default SingleEmployesAttendance